__turbopack_context__.v({
  "heartIcon": "BottomAside-module___9N0Ua__heartIcon",
  "mediaLikes": "BottomAside-module___9N0Ua__mediaLikes",
  "sideInfos": "BottomAside-module___9N0Ua__sideInfos",
});
